export interface VideoReview {
  id: string;
  title: string;
  location: string;
  product: string;
  youtubeUrl: string;
  reviewer: string;
  date: string;
  desc: string;
}

// ✅ 영상 리뷰 관리 방법:
// youtubeUrl에 유튜브 영상 URL을 붙여넣으면 자동으로 임베드됩니다.
// 예시: "https://www.youtube.com/watch?v=XXXXXXXXXXX"
// 또는: "https://youtu.be/XXXXXXXXXXX"
// 영상을 추가하려면 아래 배열에 항목을 추가하세요.

export const videoReviews: VideoReview[] = [
  {
    id: "v1",
    title: "마스터즈 8600 설치 후기",
    location: "서울 강남구",
    product: "마스터즈 도어락 8600",
    youtubeUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    reviewer: "김지수",
    date: "2026.03.15",
    desc: "지문인식 속도와 앱 연동 기능을 직접 시연해드립니다."
  },
  {
    id: "v2",
    title: "유니코 T250 실사용 리뷰",
    location: "경기 성남시",
    product: "유니코 T250",
    youtubeUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    reviewer: "박민준",
    date: "2026.03.22",
    desc: "슬림한 디자인과 터치스크린 사용감을 솔직하게 리뷰합니다."
  },
  {
    id: "v3",
    title: "도어준 설치 현장 영상",
    location: "서울 마포구",
    product: "마스터즈 도어락 7100",
    youtubeUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    reviewer: "이서연",
    date: "2026.04.01",
    desc: "전문 기사 설치 과정부터 완료까지 전 과정을 담았습니다."
  },
];
